import { Enums } from "@/enums";
import * as devalue from "devalue";
import { isNotNil } from "es-toolkit";
import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const SubscriptionDismantleRoutes = defineRoute({
    record: {
        route: {
            path: "/subscription-dismantle",
            component: () => loadView(import("./SubscriptionDismantleTable.vue")),
        },
        build(filter?: { status?: Enums.DismantleStatusEnum.Values[] }) {
            if (isNotNil(filter)) {
                const encoded = btoa(devalue.stringify(filter));
                return `/subscription-dismantle?&filter=${encoded}`;
            }

            return "/subscription-dismantle";
        },
    },
    create: {
        route: {
            path: "/subscription-dismantle/create",
            component: () => loadView(import("./SubscriptionDismantleCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/subscription-dismantle/update/:id",
            component: () => loadView(import("./SubscriptionDismantleUpdate.vue")),
        },
        build(id: string) {
            return `/subscription-dismantle/update/${id}`;
        },
    },
});
